<script lang="ts" setup>
import { useMediaQuery } from '@vueuse/core'
import Toast from 'primevue/toast'

import CookieBanner from '@/components/common/CookieBanner.vue'
import EnvironmentFrame from '@/components/common/EnvironmentFrame.vue'
import MobileMenu from '@/layouts/site/MobileMenu.vue'
import SiteFooter from '@/layouts/site/SiteFooter.vue'
import SitePageHeader from '@/layouts/site/SitePageHeader.vue'

const isLargeScreen = useMediaQuery('(min-width: 1200px)')
</script>

<template>
  <EnvironmentFrame />
  <SitePageHeader v-if="isLargeScreen" />
  <MobileMenu v-else />
  <main>
    <RouterView />
    <Toast />
  </main>

  <SiteFooter />
  <CookieBanner />
</template>
